import { render, staticRenderFns } from "./gradeTest.vue?vue&type=template&id=6bffc23a&scoped=true"
import script from "./gradeTest.vue?vue&type=script&lang=js"
export * from "./gradeTest.vue?vue&type=script&lang=js"
import style0 from "./gradeTest.vue?vue&type=style&index=0&id=6bffc23a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bffc23a",
  null
  
)

export default component.exports